import { Component, EventEmitter, HostBinding, Input, OnDestroy, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { Subject } from 'app/shared/models/subject';
import { SubjectLink } from 'app/shared/models/subject-link';
import { Subscription } from 'rxjs';
import { SubjectLinkService } from 'app/shared/services/subject-link.service';
import { Guid } from 'app/shared/helpers/guid';
import { Relationship } from 'app/shared/models/relationship';

@Component({
  selector: 'subject-list-item',
  templateUrl: './subject-list-item.component.html',
  styleUrls: ['./subject-list-item.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class SubjectListItemComponent implements OnInit, OnDestroy {

  _subjectLink: SubjectLink;
  markers: any;
  canEdit: boolean;
  canDelete: boolean;
  restricted: boolean;
  archived: boolean;
  possibleRelationships: Relationship[];
  onSelected: Subscription;

  @Input() set subject(val: Subject | SubjectLink){
    this.update(val);
  }

  @Input() set subjectLink(val: SubjectLink){
    this.update(val);
  }

  @Input() set allowEdit(val: boolean){
    this.canEdit = val;
  }
  @Input() set allowDelete(val: boolean){
    this.canDelete = val;
  }
  @Input() allowEditRelationship = false;
  @Input() allowSelect = true;
  @Input() readOnly = false;
  @Input() admin = false;
  
  @Output() onSelect: EventEmitter<any> = new EventEmitter();
  @Output() onEdit: EventEmitter<any> = new EventEmitter();
  @Output() onDelete: EventEmitter<any> = new EventEmitter();
  @Output() onChangeRelationship: EventEmitter<any> = new EventEmitter();

  @HostBinding('class.selected') selected: boolean;

  constructor(private subjectLinkService: SubjectLinkService) { }

  ngOnInit(){
    this.onSelected = this.subjectLinkService.onSelected.subscribe((subjectLink) => {
      if (subjectLink){
        if (subjectLink && this._subjectLink && this._subjectLink.id && subjectLink.id){
          this.selected = (this._subjectLink.id === subjectLink.id);
        }
        else{
          this.selected = this._subjectLink
            && ((this._subjectLink.uid && (this._subjectLink.uid === subjectLink.uid)) 
            || (this._subjectLink.linkedSubject.uid === subjectLink.uid))
            || ((!this._subjectLink.uid) && (this._subjectLink.linkedSubject.uid === subjectLink.linkedSubject.uid));
          }
      }
    });
  }

  ngOnDestroy(){
    this.onSelected?.unsubscribe();
  }

  private update(val: Subject | SubjectLink){
    if (val instanceof SubjectLink){ 
      this._subjectLink = new SubjectLink(val); 
    }
    else 
    {
      if (val instanceof Subject){
        this._subjectLink = new SubjectLink();
        this._subjectLink.uid = Guid.newGuid();
        this._subjectLink.linkedSubject = new Subject(val);
      }
    }
    // if subject check markers
    if ('subjectMarkers' in this._subjectLink.linkedSubject){
      this.markers = this._subjectLink.linkedSubject.subjectMarkers;
    }
    else{
      this.markers = [];
    }
    // if subject check restricted
    this.restricted = ('restricted' in this._subjectLink.linkedSubject) ? this._subjectLink.linkedSubject.restricted : false;
    this.archived = ('archived' in this._subjectLink.linkedSubject) ? this._subjectLink.linkedSubject.archived : false;
    this.possibleRelationships = this._subjectLink.possibleRelationships.filter((i) => i.id !== this._subjectLink.relationshipId);
  }

  select() {
    this.onSelect.emit(this._subjectLink);
  }

  edit(){
    this.onEdit.emit(this._subjectLink);
  }

  delete(){
      this.onDelete.emit(this._subjectLink);
  }

  changeRelationship(subjectLink, relationship){
    this.onChangeRelationship.emit({subjectLink, relationship});
  }
}
